<template>
    <div>
      <Header/>
      <transition name="spinner-fade">
        <Spinner v-if="loading"/>
      </transition>
      <router-view v-show="!loading && !loadingError"/>
      <LoadingError v-show="!loading && loadingError"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import Header from '@/components/Header.vue'
import Spinner from '@/components/Spinner'
import Notify from '@/mixins/notify'
import LoadingError from '@/components/LoadingError'

export default {
  name: 'ExaminerApp',
  mixins: [Notify],
  components: {
    Spinner,
    Header,
    LoadingError
  },
  computed: mapState([
    'loading',
    'loadingError',
  ])
}
</script>

<style lang="scss">
@import "~@/styles/base.scss";

.spinner-fade-enter {
  opacity: 0;
}

.spinner-fade-enter-active {
  transition: opacity 0.6s;
}

.spinner-fade-leave {
}

.spinner-fade-leave-active {
  transition: opacity 0.1s;
  opacity: 0;
}

</style>
